
const ProjectList = {
    Wecourier     : 'wecourier',
    WecourierSAAS : 'wecourier-saas',
    Weerp         : 'weerp' ,
    WeerpNormal   : 'weerp-normal',
    Wemover       : 'wemover',
    WeDelivery    : 'wedelivery' 
}
export {ProjectList};